module.exports = __webpack_public_path__ + "static/media/icon_kbd_come_back.a81a56cd.png";